import classNames from 'classnames'
import { useRouter } from 'next/router'
import BSCard from 'react-bootstrap/Card'

import Spinner from '@/components/Spinner/Spinner'
import { CommanderPageProps } from '@/types/page'

import styles from './NavigationPanel.module.scss'
import NavigationPanelBudget from './NavigationPanelBudget'
import NavigationPanelPartners from './NavigationPanelPartners'
import NavigationPanelTags from './NavigationPanelTags'
import NavigationPanelThemes from './NavigationPanelThemes'
import NavigationPanelTop from './NavigationPanelTop'

type Props = {
  data: CommanderPageProps['data']
}

const NavigationPanel = ({ data }: Props) => {
  const router = useRouter()
  const card = data.container.json_dict.card

  if (!card) {
    return (
      <BSCard className={classNames(styles.navigation, 'justify-content-center shadow-sm')}>
        <Spinner className='fa-2x' />
      </BSCard>
    )
  }

  if (router.asPath.startsWith('/cards') && !card.legal_commander && !card.type.includes('Background')) {
    return null
  }

  const tagLinks = data.panels?.taglinks
  const tribeLinks = data.panels?.tribelinks
  const themes = tribeLinks?.themes || tribeLinks // TODO remove tribeLinks.themes support after backend update

  const regex = /(\/budget|\/expensive)$/
  const match = router.asPath.match(regex)
  const budgetSuffix = match ? match[0] : ''

  const hasBudget =
    !router.query.themeName ||
    ['budget', 'expensive'].includes(router.query.themeName as string) ||
    (themes?.find((tribelink) => tribelink['href-suffix'] === `/${router.query.themeName}`)?.count || 0) > 9

  return (
    <BSCard
      className={classNames(styles.navigation, 'shadow-sm', {
        'justify-content-start': themes?.length === 0,
      })}
    >
      <NavigationPanelTop budgetSuffix={budgetSuffix} card={card} />
      {tagLinks || tribeLinks ? (
        <>
          <NavigationPanelBudget
            disabled={!hasBudget}
            sanitized={card.sanitized || ''}
            sanitized_wo={card.sanitized_wo || ''}
          />
          {router.asPath.startsWith('/tags') && tagLinks ? (
            <NavigationPanelTags budgetSuffix={budgetSuffix} sanitized_wo={card.sanitized_wo || ''} tags={tagLinks} />
          ) : (
            <NavigationPanelThemes budgetSuffix={budgetSuffix} sanitized_wo={card.sanitized_wo || ''} themes={themes} />
          )}
        </>
      ) : (
        data.partnercounts && <NavigationPanelPartners partnercounts={data.partnercounts} />
      )}
    </BSCard>
  )
}

export default NavigationPanel
